
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/rudderstack",
      function () {
        return require("private-next-pages/destinations/rudderstack.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/rudderstack"])
      });
    }
  